/**
 * API Data Source Wizard Step Constants
 * Shared across Registers and Masters modules.
 */

export const WIZARD_STEPS = Object.freeze({
  CONFIGURE_API: 1,
  TEST_PREVIEW: 2,
  MAP_COLUMNS: 3,
  SCHEDULE: 4,
  REVIEW: 5,
});

export const TOTAL_STEPS = 5;

export const STEP_INFO = Object.freeze([
  {
    step: WIZARD_STEPS.CONFIGURE_API,
    title: 'Configure API',
    description: 'Connection settings',
    icon: 'mdi-api',
  },
  {
    step: WIZARD_STEPS.TEST_PREVIEW,
    title: 'Test & Preview',
    description: 'Verify connection',
    icon: 'mdi-connection',
  },
  {
    step: WIZARD_STEPS.MAP_COLUMNS,
    title: 'Map Fields',
    description: 'Match columns',
    icon: 'mdi-link-variant',
  },
  {
    step: WIZARD_STEPS.SCHEDULE,
    title: 'Schedule',
    description: 'Auto-pull settings',
    icon: 'mdi-clock-outline',
  },
  {
    step: WIZARD_STEPS.REVIEW,
    title: 'Review',
    description: 'Confirm & save',
    icon: 'mdi-check-circle-outline',
  },
]);

export function getStepInfo(stepNumber) {
  return STEP_INFO.find(s => s.step === stepNumber);
}

export function isValidStep(stepNumber) {
  return stepNumber >= WIZARD_STEPS.CONFIGURE_API && stepNumber <= WIZARD_STEPS.REVIEW;
}

export function calculateProgress(currentStep) {
  if (currentStep < WIZARD_STEPS.CONFIGURE_API) return 0;
  if (currentStep >= WIZARD_STEPS.REVIEW) return 100;
  return Math.round(((currentStep - 1) / (TOTAL_STEPS - 1)) * 100);
}

export default {
  WIZARD_STEPS,
  TOTAL_STEPS,
  STEP_INFO,
  getStepInfo,
  isValidStep,
  calculateProgress,
};
